import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
import { createLegoComponent } from '../../core/utils/legoUtils';
import Config from '../../config';
import { getStyledText } from '../../helpers/styled';
import { responsiveStyles } from '../../core/utils/responsiveStyles';
export var Box = withTheme(styled.div.withConfig({
  displayName: "style__Box",
  componentId: "sc-1fove1f-0"
})(function (_ref) {
  var coreTheme = _ref.coreTheme,
    isLast = _ref.isLast,
    isFirst = _ref.isFirst,
    bordered = _ref.bordered;
  return css(["box-sizing:border-box;display:flex;flex-direction:column;justify-content:center;overflow:hidden;max-height:100%;padding:0 ", " 0 ", ";"], !isLast ? "".concat(coreTheme.space_2, "px") : 0, !isFirst || bordered ? "".concat(coreTheme.space_4, "px") : 0);
}));
export var Columns = withTheme(styled.div.withConfig({
  displayName: "style__Columns",
  componentId: "sc-1fove1f-1"
})(["display:flex;flex-direction:row;min-height:", ";", ""], function (props) {
  return props.tall ? "".concat(props.coreTheme.listItem.minHeightTall, "px") : "".concat(props.coreTheme.listItem.minHeight, "px");
}, function (props) {
  return !!props.onClick && "cursor: pointer;";
}));
export var Column = withTheme(styled.div.withConfig({
  displayName: "style__Column",
  componentId: "sc-1fove1f-2"
})(["display:flex;flex:", ";align-items:", ";min-width:0;"], function (props) {
  return props.width === 'content' ? 1 : 'none';
}, function (props) {
  return props.coreTheme.listItem.controlAlignItems;
}));
export var Title = withTheme(getStyledText('boldBody')(function (_ref2) {
  var coreTheme = _ref2.coreTheme,
    maxLine = _ref2.maxLine;
  return css(["overflow:hidden;color:", ";line-height:", ";text-overflow:ellipsis;", ";display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:", ";"], coreTheme.listItem.colorTextTitle, coreTheme.listItem.lineHeight, Config.media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        line-height: ", ";\n      "])), coreTheme.listItem.lineHeightTitleMD), maxLine);
}));
export var SubTitle = withTheme(getStyledText('smallBody', {
  lineHeight: 'compact'
})(function (_ref3) {
  var coreTheme = _ref3.coreTheme,
    maxLine = _ref3.maxLine;
  return css(["flex:none;overflow:hidden;color:", ";text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:", ";line-height:", ";", ";"], coreTheme.listItem.colorTextSubtitle, maxLine, coreTheme.listItem.lineHeight, Config.media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        line-height:  ", ";\n      "])), coreTheme.listItem.lineHeightSubtitleMD));
}));
export var TagWrapper = styled.div.withConfig({
  displayName: "style__TagWrapper",
  componentId: "sc-1fove1f-3"
})(["position:absolute;bottom:0;width:100%;"]);
export var Tag = withTheme(styled.span.withConfig({
  displayName: "style__Tag",
  componentId: "sc-1fove1f-4"
})(function (_ref4) {
  var coreTheme = _ref4.coreTheme;
  return css(["text-align:center;height:", ";position:absolute;bottom:0;background:", ";font-family:", ";letter-spacing:", ";line-height:", ";color:", ";padding:", ";width:100%;box-sizing:border-box;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;-webkit-line-clamp:1;", ""], coreTheme.tag.controlHeight, coreTheme.tag.colorBg, coreTheme.tag.fontFamily, coreTheme.tag.letterSpacing, coreTheme.tag.lineHeight, coreTheme.tag.colorText, coreTheme.tag.padding, Object.assign({}, responsiveStyles({
    fontSize: coreTheme.tag.fontSize
  }, coreTheme)));
}));
export var ListItemPointsContainer = withTheme(getStyledText('smallBody')(function () {
  return css(["display:flex;align-items:center;svg{margin-right:4px;}"]);
}));
export var LeftContainer = withTheme(styled.div.withConfig({
  displayName: "style__LeftContainer",
  componentId: "sc-1fove1f-5"
})(["position:relative;min-height:", "px;min-width:", "px;border-radius:", "px;display:flex;align-items:center;justify-content:center;background-color:", ";> img{width:100%;}", ""], function (props) {
  return props.coreTheme.listItem.controlMinHeightBorderless;
}, function (props) {
  return props.coreTheme.listItem.controlMinWidthBorderless;
}, function (props) {
  return props.coreTheme.listItem.borderRadius;
}, function (props) {
  return props.coreTheme.listItem.colorBg;
}, function (props) {
  if (props.tall) {
    return "\n      width: 100%;\n    ";
  } else if (props.bordered) {
    return "\n      min-height: ".concat(props.coreTheme.listItem.controlMinHeight, "px; \n      height: ").concat(props.coreTheme.listItem.controlHeight, ";\n      width: ").concat(props.coreTheme.listItem.controlThumbnailWidth, "px;\n      border-radius: 0;\n\n      > img {\n        height: 100%;\n      }\n    ");
  } else {
    return "\n      min-height: ".concat(props.coreTheme.listItem.controlMinHeightBorderless, "px; \n      height: ").concat(props.coreTheme.listItem.controlMinHeightBorderless, "px;\n      width: ").concat(props.coreTheme.listItem.controlThumbnailBorderlessWidth, "px;\n      overflow: hidden;\n    ");
  }
}));
export var RightContainer = withTheme(styled.div.withConfig({
  displayName: "style__RightContainer",
  componentId: "sc-1fove1f-6"
})(["padding:0;", ""], function (props) {
  return props.bordered && "padding-right: ".concat(props.coreTheme.space_4, "px;");
}));
export var ListItemThumbnail = createLegoComponent('ListItemThumbnail', withTheme(styled.img.withConfig({
  displayName: "style__ListItemThumbnail",
  componentId: "sc-1fove1f-7"
})(["min-height:", "px;min-width:", "px;height:", ";width:", "px !important;display:block;"], function (props) {
  return props.coreTheme.listItem.controlMinHeightTall;
}, function (props) {
  return props.coreTheme.listItem.controlMinWidthTall;
}, function (props) {
  return props.coreTheme.listItem.controlWidthHeight;
}, function (props) {
  return props.coreTheme.listItem.controlWidthTall;
})));
export var ListItemImage = createLegoComponent('ListItemImage', withTheme(styled.img.withConfig({
  displayName: "style__ListItemImage",
  componentId: "sc-1fove1f-8"
})(["height:", " !important;width:", " !important;display:block;"], function (props) {
  return props.height ? "".concat(props.height, "px") : '100%';
}, function (props) {
  return props.width ? "".concat(props.width, "px") : '104px';
})));